export default class Group {

	constructor (groupData, elementsData = []) {
		this.id = parseInt(groupData.id)
		this.user_id = parseInt(groupData.user_id)
		this.name = groupData.name

		this.elements = elementsData
	}

	get elements () {
		return this._elements
	}

	set elements (data) {
		this._elements = data.constructor === Array ? data : []
	}
}



// WEBPACK FOOTER //
// ./src/classes/Group.js